<template>
  <div>
    <header-item />
    <sugg-item />
    <history-item />
    <hot-tab-item :hot-list="item.hot" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import suggestion from '../../asset/js/suggestion';
import pageExpose from '../common/mixins/pageExpose';
import HeaderItem from './components/HeaderItem';
import HistoryItem from './components/HistoryItem';
import HotTabItem from './components/HotTabItem';
import SuggItem from './components/SuggItem';

export default {
  components: {
    HeaderItem,
    SuggItem,
    HistoryItem,
    HotTabItem,
  },
  mixins: [pageExpose],
  computed: {
    ...mapState('hotsugg', ['itemData']),
    item() {
      return this.itemData;
    },
  },
  asyncData({ context, store, route }) {
    return store
      .dispatch('hotsugg/prefetchData', { context, route })
      .catch(err => console.log('[PREFETCH_ERROR]', err));
  },
  mounted() {
    suggestion.sogouSugg();
  },
};
</script>
